<template>
  <div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('admin.dashboard')" @click="navigateTo">
        <icon name="dashboard" class="w-4 h-4 mr-2 fill-current" :class="isUrl('') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Dashboard</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-orders')">
      <inertia-link class="flex items-center group py-3" :href="route('customer.orders')" @click="navigateTo">
        <icon name="shopping-cart" class="w-4 h-4 mr-2 fill-current" :class="isUrl('customer-orders') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('customer-orders') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Orders</div>
      </inertia-link>
    </div>

    <GroupMenuItem
        label="Dispatch Notes"
        :active="route().current('delivery-notes.index')
          || route().current('dispatches.*')"
    >
      <div class="mb-3" v-if="canAdmin('warehouse-manager-role') || canAdmin('access-dispatch-notes')">
        <inertia-link class="flex items-center group py-3 whitespace-nowrap" :href="route('dispatches.handover-list')" @click="navigateTo">
          <icon name="clipboard" class="w-5 h-5 mr-2" :class="route().current('dispatches.handover-list') ? 'text-white' : 'text-gray-400 hover:text-white'" />
          <div :class="route().current('dispatches.handover-list') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Handover List</div>
        </inertia-link>
      </div>
      <div class="mb-3" v-if="canAdmin('access-dispatch-notes') || canAdmin('delivery-team-role')">
        <inertia-link class="flex items-center group py-3 whitespace-nowrap" :href="route('dispatches.delivery')" @click="navigateTo">
          <icon name="truck" class="w-5 h-5 mr-2" :class="route().current('dispatches.delivery') ? 'text-white' : 'text-gray-400 hover:text-white'" />
          <div :class="route().current('dispatches.delivery') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Delivery List</div>
        </inertia-link>
      </div>
    </GroupMenuItem>

    <GroupMenuItem
      label="Archives"
      :active="route().current('master-list') || route().current('delivery-list') || route().current('handover-list')"
    >
      <div class="mb-4" v-if="canAdmin('access-delivery-teams')">
        <inertia-link class="flex items-center group py-3" :href="route('master-list')" @click="navigateTo">
          <icon name="office" class="w-4 h-4 mr-2 fill-current" :class="isUrl('master-list') ? 'text-white' : 'text-gray-400 hover:text-white'" />
          <div :class="isUrl('master-list') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Master List</div>
        </inertia-link>
      </div>

      <div class="mb-4" v-if="canAdmin('delivery-team-role')">
        <inertia-link class="flex items-center group py-3" :href="route('delivery-list')" @click="navigateTo">
          <icon name="office" class="w-4 h-4 mr-2 fill-current" :class="isUrl('delivery-list') ? 'text-white' : 'text-gray-400 hover:text-white'" />
          <div :class="isUrl('delivery-list') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Delivery List</div>
        </inertia-link>
      </div>

      <div class="mb-4" v-if="canAdmin('warehouse-manager-role')">
        <inertia-link class="flex items-center group py-3" :href="route('handover-list')" @click="navigateTo">
          <icon name="office" class="w-4 h-4 mr-2 fill-current" :class="isUrl('handover-list') ? 'text-white' : 'text-gray-400 hover:text-white'" />
          <div :class="isUrl('handover-list') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Handover List</div>
        </inertia-link>
      </div>
    </GroupMenuItem>

    <div class="mb-4" v-if="canAdmin('access-customers')">
      <inertia-link class="flex items-center group py-3" :href="route('customers')" @click="navigateTo">
        <icon name="office" class="w-4 h-4 mr-2 fill-current" :class="isUrl('organizations') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('customers') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Customers</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-payments-report')">
      <inertia-link class="flex items-center group py-3" :href="route('manage.payments-report.index')" @click="navigateTo">
        <icon name="office" class="w-4 h-4 mr-2 fill-current" :class="isUrl('payments-report') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('payments-report') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Customer Payments</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-delivery-teams')">
      <inertia-link class="flex items-center group py-3" :href="route('manage.delivery_teams')" @click="navigateTo">
        <icon name="users" class="w-4 h-4 mr-2 fill-current" :class="isUrl('reports') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('manage.delivery_teams') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Delivery Teams</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-announcements')">
      <inertia-link class="flex items-center group py-3" :href="route('manage.announcements')" @click="navigateTo">
        <icon name="bell" class="w-4 h-4 mr-2 fill-current" :class="isUrl('announcements') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('announcements') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Annoucements</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-warehouses')">
      <inertia-link class="flex items-center group py-3" :href="route('manage.warehouses')" @click="navigateTo">
        <icon name="warehouse" class="w-4 h-4 mr-2 fill-current" :class="isUrl('warehouses') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('warehouses') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Warehouses</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-products')">
      <inertia-link class="flex items-center group py-3" :href="route('manage.products')" @click="navigateTo">
        <icon name="products" class="w-4 h-4 mr-2 fill-current" :class="isUrl('products') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('products') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Products</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-special-offers')">
      <inertia-link class="flex items-center group py-3 hover:text-white" :href="route('manage.offers')" @click="navigateTo">
        <icon name="products" class="w-4 h-4 mr-2 fill-current" :class="isUrl('offers') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('offers') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Discounts & Offers</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-products')">
      <inertia-link class="flex items-center group py-3" :href="route('manage.categories')" @click="navigateTo">
        <icon name="products" class="w-4 h-4 mr-2 fill-current" :class="isUrl('categories') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('categories') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Product Categories</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-inventory')">
      <inertia-link class="flex items-center group py-3" :href="route('admin.inventory')" @click="navigateTo">
        <icon name="book" class="w-4 h-4 mr-2 fill-current" :class="isUrl('inventory') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('inventory') ? 'text-white' : 'text-gray-400 group-hover:text-white'">LS Inventory</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-reports')">
      <inertia-link class="flex items-center group py-3" :href="route('admin.reports')" @click="navigateTo">
        <icon name="book" class="w-4 h-4 mr-2 fill-current" :class="isUrl('reports') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('reports') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Reports</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('access-boats')">
      <inertia-link class="flex items-center group py-3" :href="route('manage.boats')" @click="navigateTo">
        <icon name="book" class="w-4 h-4 mr-2 fill-current" :class="isUrl('boats') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('boats') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Manage Boats</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('manage-system-settings')">
      <inertia-link class="flex items-center group py-3" :href="route('admin.settings')" @click="navigateTo">
        <icon name="settings" class="w-4 h-4 mr-2 fill-current" :class="isUrl('admin-settings') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('admin-settings') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Settings</div>
      </inertia-link>
    </div>

    <div class="mb-4" v-if="canAdmin('manage-system-roles')">
      <inertia-link class="flex items-center group py-3" :href="route('admin.roles')" @click="navigateTo">
        <icon name="settings" class="w-4 h-4 mr-2 fill-current" :class="isUrl('admin-roles') ? 'text-white' : 'text-gray-400 hover:text-white'" />
        <div :class="isUrl('admin-roles') ? 'text-white' : 'text-gray-400 group-hover:text-white'">Admin Roles</div>
      </inertia-link>
    </div>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import GroupMenuItem from "./GroupMenuItem.vue";

export default {
  components: {
    GroupMenuItem,
    Icon,
  },
  props: {
    url: String,
  },
  methods: {
    isUrl(...urls) {
      if (urls[0] === '') {
        return this.url === ''
      }

      return urls.filter(url => this.url.startsWith(url)).length
    },
    navigateTo() {
      // this.$inertia.visit(url, {
      //   onFinish: () => this.$emit('visit'),
      // })
      this.$emit('visit');
    }
  },
}
</script>
